import React from "react";
import {
  Star,
  ShieldCheck,
  Instagram,
  Facebook,
  MessageCircle,
  Globe,
  CalendarCheck2,
  Music2,
} from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ICONS = [Star, ShieldCheck, Instagram, Music2, Facebook, MessageCircle, Globe, CalendarCheck2];

export default function Solution() {
  const { t } = useLang();
  return (
    <section id="product" className="section-y bg-brand-cloud" data-testid="solution-section">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="overline">{t.solution.overline}</span>
          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
            {t.solution.title}
          </h2>
          <p className="mt-6 text-lg text-brand-graphite leading-relaxed text-pretty">
            {t.solution.body}
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {t.solution.platforms.map((name, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={name}
                className="card-soft card-soft-hover p-5 md:p-6 flex flex-col items-start gap-4"
                data-testid={`solution-platform-${i}`}
              >
                <span className="grid place-items-center h-10 w-10 rounded-2xl bg-brand-ink text-white">
                  <Icon className="h-5 w-5" />
                </span>
                <div className="text-sm md:text-base font-medium text-brand-ink">{name}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
